/* eslint-disable no-shadow */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";

function OpportunitiesMobile({ app, config }) {


	return (
		<></>
	);
}

OpportunitiesMobile.defaultProps = {
	app: null,
	config: {},
};

OpportunitiesMobile.propTypes = {
	app: PropTypes.object,
	config: PropTypes.object,
};

export default OpportunitiesMobile;
